import PdfImg from '@/assets/pdf.png'
import XlsImg from '@/assets/xls.png'

export default ({ data }) => {
  let { attachmentUrl, fromType } = data
  if (!attachmentUrl) return {}
  const fileList = attachmentUrl.split(',')

  return {
    title: '附件',
    form: [
      {
        type: 'text',
        value: `<div style="display:flex; ">${fileList.map((item) => {
          let img = item
          if (img.includes('.pdf')) {
            img = PdfImg
          }
          if (img.includes('.xls')) {
            img = XlsImg
          }
          return `<img
              onclick="window.open('${item}')" 
              src="${img}"
              style="width: 60px;height: 60px; margin-right: 10px;margin: 0 10px 10px 0;border-radius: 8px;"
            />`
        })}</div>`,
      },
    ],
  }
}
